import { useState } from "react";
import { Container, Form, Button, Row, Col, Accordion } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
 
import { saveEventDetails } from "../Api/Event";
import { fetchProjectsByOrg } from "../Api/ViewProjects";
import { getTicketsByOrgId } from "../Api/TicketApiOrg";
 
import Sample14 from "../Components/Logo";
 
import {
  FaCalendarAlt,
  FaUsers,
  FaBell,
  FaClipboardList,
} from "react-icons/fa";
 
const Event = () => {
  const navigate = useNavigate();
 
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
 
  const orgId = String(userDetails?.organisationId);
  const userId = String(userDetails?.userId);
 
  const [loading, setLoading] = useState(false);
 
  const [projects, setProjects] = useState([]);
  const [tickets, setTickets] = useState([]);
 
  const [participants, setParticipants] = useState([]);
 
  const [reminderMinutes, setReminderMinutes] = useState("");
  const [reminderType, setReminderType] = useState("");
  const [isSent, setIsSent] = useState(false);
 
  const [mom, setMom] = useState({
    preparedBy: "",
    approvedBy: "",
    discussionPoints: "",
    decisionsTaken: "",
    actionItems: "",
  });
 
  const [eventData, setEventData] = useState({
    eventName: "",
    eventType: "",
    eventDate: "",
    eventEndDate: "",
    eventLocation: "",
    organizerName: "",
    budgetAllocation: "",
    department: "",
    eventDescription: "",
    entityType: "",
    entityId: "",
    createdBy: userId,
    organisationId: orgId,
  });
 
  const handleChange = async (e) => {
    const { name, value } = e.target;
 
    setEventData({
      ...eventData,
      [name]: value,
    });
 
    try {
      if (name === "entityType" && value === "Project") {
        const data = await fetchProjectsByOrg(orgId);
        setProjects(data);
      }
 
      if (name === "entityType" && value === "Ticket") {
        const data = await getTicketsByOrgId(orgId);
        setTickets(data);
      }
    } catch {
      toast.error("Error loading entity data");
    }
  };
 
  const projectOptions = projects.map((p) => ({
    value: p.projectId,
    label: `${p.prTitle} (${p.projectId})`,
  }));
 
  const ticketOptions = tickets.map((t) => ({
    value: t.ticketId,
    label: `${t.ticketName} (${t.ticketId})`,
  }));
 
  const handleSubmit = async (e) => {
    e.preventDefault();
 
    try {
      setLoading(true);
 
      const payload = {
        ...eventData,
 
        eventDate: new Date(eventData.eventDate).toISOString(),
 
        eventEndDate: eventData.eventEndDate
          ? new Date(eventData.eventEndDate).toISOString()
          : null,
 
        participants: participants.map((p) => ({
          userId: p.userId,
          participantRole: p.participantRole,
          status: p.status,
          createdBy: userId,
          organisationId: orgId,
        })),
 
        reminders: reminderMinutes
          ? [
              {
                reminderMinutes: Number(reminderMinutes),
                reminderType,
                isSent,
                createdBy: userId,
                organisationId: orgId,
              },
            ]
          : [],
 
        minutesOfMeeting: {
          preparedBy: mom.preparedBy,
          approvedBy: mom.approvedBy,
          discussionPoints: mom.discussionPoints,
          decisionsTaken: mom.decisionsTaken,
          actionItems: mom.actionItems,
          createdBy: userId,
          organisationId: orgId,
        },
      };
 
      await saveEventDetails(payload);
 
      toast.success("Event Created Successfully");
 
      navigate("/viewEvent");
    } catch {
      toast.error("Error saving event");
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <div
      className="container resource-master-fields"
      style={{ marginTop: "30px" }}
    >
      <h2 className="fields-title">
        <span style={{ fontSize: "2rem", fontWeight: 700 }}>Event Master</span>
      </h2>
 
      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
 
      <Form onSubmit={handleSubmit} className="fields-form">
        <Accordion defaultActiveKey="0" alwaysOpen>
          {/* EVENT DETAILS */}
 
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <div className="details-header-content">
                <FaCalendarAlt
                  style={{ fontSize: "15px", marginLeft: "10px" }}
                />
                <span style={{ fontSize: "15px", margin: "7px" }}>
                  Event Details
                </span>
              </div>
            </Accordion.Header>
 
            <Accordion.Body>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Event Name</Form.Label>
                    <Form.Control
                      name="eventName"
                      value={eventData.eventName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
 
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Event Type</Form.Label>
                    <Form.Control
                      name="eventType"
                      value={eventData.eventType}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
 
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Event Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="eventDate"
                      value={eventData.eventDate}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
 
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="eventEndDate"
                      value={eventData.eventEndDate}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
 
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Location</Form.Label>
                    <Form.Control
                      name="eventLocation"
                      value={eventData.eventLocation}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
 
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Organizer</Form.Label>
                    <Form.Control
                      name="organizerName"
                      value={eventData.organizerName}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
 
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Budget</Form.Label>
                    <Form.Control
                      type="number"
                      name="budgetAllocation"
                      value={eventData.budgetAllocation}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
 
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Department</Form.Label>
                    <Form.Control
                      name="department"
                      value={eventData.department}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
 
              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="eventDescription"
                      value={eventData.eventDescription}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
 
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Entity Type</Form.Label>
                    <Form.Select
                      name="entityType"
                      value={eventData.entityType}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Ticket">Ticket</option>
                      <option value="Project">Project</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
 
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Entity Id</Form.Label>
 
                    {eventData.entityType === "Project" ? (
                      <Select
                        options={projectOptions}
                        onChange={(e) =>
                          setEventData({ ...eventData, entityId: e.value })
                        }
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    ) : eventData.entityType === "Ticket" ? (
                      <Select
                        options={ticketOptions}
                        onChange={(e) =>
                          setEventData({ ...eventData, entityId: e.value })
                        }
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    ) : (
                      <Form.Control
                        name="entityId"
                        value={eventData.entityId}
                        onChange={handleChange}
                      />
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
 
          {/* PARTICIPANTS */}
 
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <div className="details-header-content">
                <FaUsers style={{ fontSize: "15px", marginLeft: "10px" }} />
                <span style={{ fontSize: "15px", margin: "7px" }}>
                  Participants
                </span>
              </div>
            </Accordion.Header>
 
            <Accordion.Body>
              {participants.map((p, i) => (
                <Row key={i} className="mb-3">
                  <Col md={4}>
                    <Form.Control
                      placeholder="User Id"
                      value={p.userId}
                      onChange={(e) => {
                        const arr = [...participants];
                        arr[i].userId = e.target.value;
                        setParticipants(arr);
                      }}
                    />
                  </Col>
 
                  <Col md={4}>
                    <Form.Control
                      placeholder="Role"
                      value={p.participantRole}
                      onChange={(e) => {
                        const arr = [...participants];
                        arr[i].participantRole = e.target.value;
                        setParticipants(arr);
                      }}
                    />
                  </Col>
 
                  <Col md={4}>
                    <Form.Select
                      value={p.status}
                      onChange={(e) => {
                        const arr = [...participants];
                        arr[i].status = e.target.value;
                        setParticipants(arr);
                      }}
                    >
                      <option value="">Status</option>
                      <option value="Accepted">Accepted</option>
                      <option value="Pending">Pending</option>
                      <option value="Declined">Declined</option>
                    </Form.Select>
                  </Col>
                </Row>
              ))}
 
              <Button
                variant="secondary"
                onClick={() =>
                  setParticipants([
                    ...participants,
                    { userId: "", participantRole: "", status: "" },
                  ])
                }
              >
                Add Participant
              </Button>
            </Accordion.Body>
          </Accordion.Item>
 
          {/* REMINDER */}
 
          <Accordion.Item eventKey="2">
            <Accordion.Header style={{ fontSize: "18px", margin: "11px" }}>
              <FaBell style={{ fontSize: "15px", marginLeft: "10px" }} />
              <span style={{ fontSize: "15px", margin: "7px" }}>
                {" "}
                Reminder{" "}
              </span>
            </Accordion.Header>
 
            <Accordion.Body>
              <Row>
                <Col md={4}>
                  <Form.Control
                    type="number"
                    placeholder="Minutes"
                    value={reminderMinutes}
                    onChange={(e) => setReminderMinutes(e.target.value)}
                  />
                </Col>
 
                <Col md={4}>
                  <Form.Select
                    value={reminderType}
                    onChange={(e) => setReminderType(e.target.value)}
                  >
                    <option value="">Type</option>
                    <option value="Email">Email</option>
                    <option value="Notification">Notification</option>
                    <option value="SMS">SMS</option>
                  </Form.Select>
                </Col>
 
                <Col md={4}>
                  <Form.Select
                    value={isSent}
                    onChange={(e) => setIsSent(e.target.value === "true")}
                  >
                    <option value="">Is Sent</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </Form.Select>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
 
          {/* MOM */}
 
          <Accordion.Item eventKey="3">
            <Accordion.Header style={{ fontSize: "18px", margin: "11px" }}>
              <FaClipboardList
                style={{ fontSize: "15px", marginLeft: "10px" }}
              />
              <span style={{ fontSize: "15px", margin: "7px" }}>
                {" "}
                MoM (Minutes of Meeting){" "}
              </span>
            </Accordion.Header>
 
            <Accordion.Body>
              <Row>
                <Col md={6}>
                  <Form.Control
                    placeholder="Prepared By"
                    onChange={(e) =>
                      setMom({ ...mom, preparedBy: e.target.value })
                    }
                  />
                </Col>
 
                <Col md={6}>
                  <Form.Control
                    placeholder="Approved By"
                    onChange={(e) =>
                      setMom({ ...mom, approvedBy: e.target.value })
                    }
                  />
                </Col>
              </Row>
 
              <Row className="mt-3">
                <Col md={12}>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Discussion Points"
                    onChange={(e) =>
                      setMom({ ...mom, discussionPoints: e.target.value })
                    }
                  />
                </Col>
              </Row>
 
              <Row className="mt-3">
                <Col md={12}>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Decisions Taken"
                    onChange={(e) =>
                      setMom({ ...mom, decisionsTaken: e.target.value })
                    }
                  />
                </Col>
              </Row>
 
              <Row className="mt-3">
                <Col md={12}>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Action Items"
                    onChange={(e) =>
                      setMom({ ...mom, actionItems: e.target.value })
                    }
                  />
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
 
        <div className="fields-btn-container" style={{ marginTop: 20 }}>
          <Button
            variant="primary"
            type="submit"
            disabled={loading}
            style={{ padding: "15px 35px", fontSize: "15px" }}
          >
            {loading ? "Saving..." : "Save Event"}
          </Button>
        </div>
      </Form>
    </div>
  );
};
 
export default Event;